import type { EventLogger } from 'lib/EventLogger';
import { createContext } from 'react';
import UserData from 'lib/EventLogger/User';
import { OptimizelyDecisionsParams } from 'lib/hooks/useOptimizelyDecisions';

const nullLogger = {
  async log(): Promise<void> {},
};

export default createContext<{
  log: EventLogger['log'];
  user?: UserData;
  optimizelyDecisions?: OptimizelyDecisionsParams;
}>(nullLogger);
